// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign from "../Foreign/index.js";
var removeClass = function (cls) {
    return $foreign.setClass(cls)(false);
};
var on$prime = $foreign.delegate;
var off$prime = $foreign.deafen;
var hide = /* #__PURE__ */ $foreign.setVisible(false);
var getAttr = function (str) {
    return function (jq) {
        var foreignToString = function (f) {
            var $0 = Foreign.isUndefined(f);
            if ($0) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(Foreign.unsafeFromForeign(f));
        };
        return Data_Functor.map(Effect.functorEffect)(foreignToString)($foreign.getAttrImpl(str)(jq));
    };
};
var display = /* #__PURE__ */ $foreign.setVisible(true);
var addClass = function (cls) {
    return $foreign.setClass(cls)(true);
};
export {
    ready,
    select,
    find,
    parent,
    closest,
    create,
    setAttr,
    attr,
    css,
    hasClass,
    toggleClass,
    setClass,
    setProp,
    getProp,
    append,
    remove,
    clear,
    before,
    appendText,
    body,
    getText,
    setText,
    getHtml,
    setHtml,
    getValue,
    setValue,
    toggle,
    setVisible,
    on,
    off,
    toArray,
    preventDefault,
    stopPropagation,
    stopImmediatePropagation,
    getTarget,
    getCurrentTarget,
    getPageX,
    getPageY,
    getWhich,
    getMetaKey,
    clone,
    cloneWithDataAndEvents
} from "./foreign.js";
export {
    getAttr,
    addClass,
    removeClass,
    hide,
    display,
    on$prime,
    off$prime
};
//# sourceMappingURL=index.js.map
